module.exports = __webpack_public_path__ + "static/img/hjk_link_btn.1250739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/hjk_link_btn.png
// module id = via7
// module chunks = 0